import { createRootRoute, Outlet } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/layout";

const RootLayout = () => {
	return (
		<DashboardLayout>
			<Outlet />
		</DashboardLayout>
	);
};

export const Route = createRootRoute({
	component: RootLayout,
});
